// @flow
import { css } from "styled-components";

export const ieMediaQuery = (style: any) => css`
	@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)  {
		${style}
	}
`;

export default ieMediaQuery;